$(function () {
    /**
     * Threshold in pixels for snapping to the center (50%).
     * Adjust as needed for better user experience.
     */
    const SNAP_PX = 10;

    $('.comparison-before-and-after').each(function () {
        const $block = $(this);
        const $comparison = $block.find('.comparison');
        const $after = $comparison.find('.comparison__after');
        const $handle = $comparison.find('.comparison__handle');
        const $beforeBtn = $block.find('[data-reveal="before"]');
        const $afterBtn = $block.find('[data-reveal="after"]');
        let dragging = false;

        const setActive = ($btn) => {
            $beforeBtn.removeClass('is-active');
            $afterBtn.removeClass('is-active');
            if ($btn) $btn.addClass('is-active');
        };

        const setPosition = (pct) => {
            $after.css('clip-path', `inset(-1px -1px -1px ${pct}%)`);
            $handle.css('left', `${pct}%`);
        };

        const setPositionFromClientX = (clientX) => {
            const offset = $comparison.offset().left;
            const width = $comparison.outerWidth();
            let pct = Math.min(100, Math.max(0, (clientX - offset) / width * 100));
            const snapThresholdPct = SNAP_PX / width * 100;
            if (Math.abs(pct - 50) <= snapThresholdPct) {
                pct = 50;
            }
            setPosition(pct);
            if (pct <= 5) {
                setActive($afterBtn);
            } else if (pct >= 95) {
                setActive($beforeBtn);
            } else {
                setActive(null);
            }
        };

        const animateTo = (pct, $activeBtn) => {
            $after.css('transition', 'clip-path 0.4s ease');
            $handle.css('transition', 'left 0.4s ease');
            setPosition(pct);
            setActive($activeBtn);
            setTimeout(() => {
                $after.css('transition', '');
                $handle.css('transition', '');
            }, 400);
        };

        $handle.on('mousedown', (e) => {
            e.preventDefault();
            dragging = true;
        });

        $handle[0].addEventListener('touchstart', () => {
            dragging = true;
        }, { passive: true });

        $(document).on('mousemove', (e) => {
            if (!dragging) return;
            setPositionFromClientX(e.clientX);
        });

        document.addEventListener('touchmove', (e) => {
            if (!dragging) return;
            e.preventDefault();
            setPositionFromClientX(e.touches[0].clientX);
        }, { passive: false });

        $(document).on('mouseup touchend', () => {
            dragging = false;
        });

        // pct=0 → after image fully visible; pct=100 → before image fully visible
        $afterBtn.on('click', () => animateTo(0, $afterBtn));
        $beforeBtn.on('click', () => animateTo(100, $beforeBtn));
    });
});
